export function buildNoDataToken(helperName?: string, detail?: string): string {
  if (helperName) {
    return `[ ${helperName}: No data${detail ? `: ${detail}` : ''} ]`;
  }
  return `[ No data${detail ? `: ${detail}` : ''} ]`;
}

export function buildErrorToken(
  errorType: string,
  helperName?: string,
  detail?: string
): string {
  if (helperName) {
    return `[ ${helperName}: ${errorType}${detail ? `: ${detail}` : ''} ]`;
  }
  return `[ ${errorType}${detail ? `: ${detail}` : ''} ]`;
}
